import { Controller } from "@hotwired/stimulus"
import { formatMoney } from "../modules/product_wizard.mjs"

// Precio con miles: visible "2.640", hidden product[price] "2640" (solo dígitos, hasta 7).
// Doc: _docs/features/products/partner_product_form.md
export default class extends Controller {
  static targets = ["display", "value"]

  connect() {
    this.format()
  }

  format() {
    const digits = this.displayTarget.value.replace(/\D/g, "").slice(0, 7)
    this.valueTarget.value = digits
    const text = digits ? formatMoney(digits).slice(1) : ""
    if (this.displayTarget.value !== text) this.displayTarget.value = text
  }

  // Borrador local: el monto del hidden; al restaurar pasa por format()
  get draft() {
    return this.valueTarget.value
  }

  restoreDraft(amount) {
    this.displayTarget.value = String(amount ?? "")
    this.format()
    return { skipped: 0 }
  }
}
